// source: code_applicability.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var task_pb = require('./task_pb.js');
goog.object.extend(proto, task_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.applicability.CodeApplicabilityStep', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalProjectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 9, ""),
maxRelevantChapters: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
specificChapterIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
specificSectionIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
minSectionDepth: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
maxSectionDepth: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
forceRecompute: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest;
  return proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxRelevantChapters(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addSpecificChapterIds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addSpecificSectionIds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinSectionDepth(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxSectionDepth(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceRecompute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSpecificChapterIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getSpecificSectionIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getForceRecompute();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string architectural_project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getArchitecturalProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setArchitecturalProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 max_relevant_chapters = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getMaxRelevantChapters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setMaxRelevantChapters = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.clearMaxRelevantChapters = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.hasMaxRelevantChapters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string specific_chapter_ids = 5;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getSpecificChapterIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setSpecificChapterIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.addSpecificChapterIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.clearSpecificChapterIdsList = function() {
  return this.setSpecificChapterIdsList([]);
};


/**
 * repeated string specific_section_ids = 6;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getSpecificSectionIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setSpecificSectionIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.addSpecificSectionIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.clearSpecificSectionIdsList = function() {
  return this.setSpecificSectionIdsList([]);
};


/**
 * optional int32 min_section_depth = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getMinSectionDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setMinSectionDepth = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.clearMinSectionDepth = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.hasMinSectionDepth = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 max_section_depth = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getMaxSectionDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setMaxSectionDepth = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.clearMaxSectionDepth = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.hasMaxSectionDepth = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool force_recompute = 10;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.getForceRecompute = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisRequest.prototype.setForceRecompute = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse;
  return proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.applicability.StartCodeApplicabilityAnalysisResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.applicability.CodeApplicabilityStep = {
  UNKNOWN_STEP: 0,
  SERVER_WARMUP: 1,
  INITIALIZE_ANALYSIS: 2,
  LOAD_PROJECT_DATA: 3,
  INITIALIZE_INSPECTOR: 4,
  ANALYZE_CHAPTER_RELEVANCE: 5,
  FILTER_RELEVANT_CHAPTERS: 6,
  SETUP_CONTEXT_CACHING: 7,
  PROCESS_SECTIONS_BATCH: 8,
  AGGREGATE_RESULTS: 9,
  SAVE_APPLICABILITY_REPORT: 10,
  ANALYSIS_COMPLETE: 11
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service.applicability);
